/* eslint-disable jsx-a11y/anchor-is-valid */
import { Card } from "flowbite-react";
import { useEffect, useState, type FC } from "react";
import {
  HiBriefcase,
  HiCurrencyDollar,
  HiDotsVertical,
  HiHeart,
  HiMap,
  HiPhone,
} from "react-icons/hi";
import { MdComment, MdMoney } from "react-icons/md";
import NavbarSidebarLayout from "../../layouts/navbar-sidebar";
// import { memberService } from "../../services/main";
import { useParams } from "react-router";
import { LuHistory } from "react-icons/lu";
import { AiOutlineHistory } from "react-icons/ai";
import { PiDotsNineBold } from "react-icons/pi";
import { AddPaymentCardModal, EditPaymentCardModal } from "../kanban";
import toast, { Toaster } from "react-hot-toast";
import { useAppContext } from "../../context/AppContext";
const UserFeedPage: FC = function () {
  const [member, setMember] = useState();
  // const { dummy, setDummy } = useAppContext();
  const [loading, setLoading] = useState(true);

  const { memberId } = useParams();
  // useEffect(() => {
  //   const fetchMember = async () => {
  //     if (!memberId) {
  //       console.error("No memberId found in URL parameters.");
  //       return;
  //     }
  //     try {
  //       const response = await memberService.getMemberById(memberId);
  //       setMember(response.data.data);
  //     } catch (error) {
  //       console.error("Failed to fetch users:", error);
  //     } finally {
  //       setLoading(false)
  //     }
  //   };

  //   fetchMember();
  // }, [dummy]);
  console.log("thisismemeber", member);
  return (
    <NavbarSidebarLayout isFooter={false}>
      {loading ? (
        <div className="relative grid grid-cols-1 overflow-y-hidden xl:h-[calc(100vh-4rem)] xl:grid-cols-4 xl:gap-4">
          <div className="w-full space-y-10 px-4 py-6 xl:sticky xl:flex xl:flex-col">
            <div>
              <ul className="divide-y divide-gray-200 dark:divide-gray-700">
                <li className="flex items-center m-auto space-x-4">
                  <div className="h-20 w-20 bg-gray-300 dark:bg-gray-700 animate-pulse rounded-lg"></div>
                  <div className="space-y-2">
                    <div className="h-5 w-36 bg-gray-300 dark:bg-gray-700 animate-pulse rounded"></div>
                    <div className="space-y-1">
                      <div className="h-4 w-48 bg-gray-300 dark:bg-gray-700 animate-pulse rounded"></div>
                      <div className="h-4 w-40 bg-gray-300 dark:bg-gray-700 animate-pulse rounded"></div>
                      <div className="h-4 w-56 bg-gray-300 dark:bg-gray-700 animate-pulse rounded"></div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="xl:sticky">
              <h3 className="mb-4 -mt-4 h-6 w-32 bg-gray-300 dark:bg-gray-700 animate-pulse rounded"></h3>
              <ul className="divide-y divide-gray-200 dark:divide-gray-700">
                {[...Array(4)].map((_, index) => (
                  <li
                    key={index}
                    className="flex items-center space-x-4 pt-4 pb-4"
                  >
                    <div className="h-10 w-10 bg-gray-300 dark:bg-gray-700 animate-pulse rounded-lg"></div>
                    <div className="space-y-2">
                      <div className="h-4 w-40 bg-gray-300 dark:bg-gray-700 animate-pulse rounded"></div>
                      <div className="h-4 w-52 bg-gray-300 dark:bg-gray-700 animate-pulse rounded"></div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-span-2 m-auto mb-5 h-full w-full max-w-3xl space-y-6 overflow-hidden overflow-y-auto p-4 lg:pt-6">
            {/* Fixed Bottom Navigation */}
            <div className="fixed sm:relative bottom-0 z-50 w-full h-16 -translate-x-1/2 bg-white border-t border-gray-200 left-1/2 dark:bg-gray-700 dark:border-gray-600 sm:rounded-xl">
              <div className="grid h-full max-w-lg grid-cols-6 mx-auto">
                <button
                  type="button"
                  className="relative inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group"
                >
                  <div className="text-2xl dark:text-white bg-gray-300 dark:bg-gray-500 w-6 h-6 rounded-full"></div>
                  <span className="sr-only">Past Records</span>
                </button>
                <button
                  type="button"
                  className="inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group"
                >
                  <div className="w-5 h-5 bg-gray-300 dark:bg-gray-500 rounded-md"></div>
                  <span className="sr-only">Bookmark</span>
                </button>
                <div className="flex items-center justify-center col-span-2">
                  <button className="w-10 h-10 bg-gray-300 dark:bg-gray-500 rounded-full"></button>
                </div>
                <button
                  type="button"
                  className="inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group"
                >
                  <div className="w-5 h-5 bg-gray-300 dark:bg-gray-500 rounded-md"></div>
                  <span className="sr-only">Settings</span>
                </button>
                <button
                  type="button"
                  className="relative inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group"
                >
                  <div className="text-2xl font-semibold bg-gray-300  dark:bg-gray-500 w-6 h-6 rounded-full"></div>
                  <span className="sr-only">Upcoming Records</span>
                </button>
              </div>
            </div>

            {/* Transactions Section */}
            <div className="mb-2 h-6 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>

            {Array(2)
              .fill(null)
              .map((_, index) => (
                <div key={index}>
                  <div className="border-2  shadow-xl p-4 space-y-2">
                    <div className="flex items-center space-x-4">
                      <div className="shrink-0 bg-gray-300 dark:bg-gray-500 h-10 w-10 rounded-full"></div>
                      <div className="min-w-0 flex-1">
                        <div className="h-4 bg-gray-300 dark:bg-gray-500 w-24 mb-1"></div>
                        <div className="h-4 bg-gray-200 dark:bg-gray-600 w-16"></div>
                      </div>
                      <div className="h-4 bg-gray-300 dark:bg-gray-500 w-12"></div>
                      <div className="relative w-11 h-6 bg-gray-200 dark:bg-gray-600 rounded-full"></div>
                    </div>
                  </div>
                </div>
              ))}

            {/* Past Payments Section */}
            {Array(2)
              .fill(null)
              .map((_, yearIndex) => (
                <div key={yearIndex}>
                  <div className="mb-2 h-6 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>

                  {Array(2)
                    .fill(null)
                    .map((_, paymentIndex) => (
                      <div
                        key={paymentIndex}
                        className="border border-gray-200 dark:border-gray-700 p-4 space-y-2"
                      >
                        <div className="flex items-center space-x-4">
                          <div className="shrink-0 bg-gray-300 dark:bg-gray-500 h-10 w-10 rounded-full"></div>
                          <div className="min-w-0 flex-1">
                            <div className="h-4 bg-gray-300 dark:bg-gray-500 w-24 mb-1"></div>
                            <div className="h-4 bg-gray-200 dark:bg-gray-500 w-16"></div>
                          </div>
                          <div className="h-4 bg-gray-300 dark:bg-gray-500 w-12"></div>
                          <div className="bg-gray-100 dark:bg-gray-500  h-6 w-16 rounded-full"></div>
                        </div>
                      </div>
                    ))}
                </div>
              ))}

            {/* Future Payments Section */}
            {Array(2)
              .fill(null)
              .map((_, yearIndex) => (
                <div key={yearIndex}>
                  <div className="mb-2 h-6 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>

                  {Array(2)
                    .fill(null)
                    .map((_, paymentIndex) => (
                      <div
                        key={paymentIndex}
                        className="border border-gray-200 dark:border-gray-700 p-4 space-y-2"
                      >
                        <div className="flex items-center space-x-4">
                          <div className="shrink-0 bg-gray-300 dark:bg-gray-500 h-10 w-10 rounded-full"></div>
                          <div className="min-w-0 flex-1">
                            <div className="h-4 bg-gray-300 dark:bg-gray-500 w-24 mb-1"></div>
                            <div className="h-4 bg-gray-200 dark:bg-gray-600 w-16"></div>
                          </div>
                          <div className="h-4 bg-gray-300 dark:bg-gray-500 w-12"></div>
                          <div className="bg-gray-100 dark:bg-gray-700 h-6 w-16 rounded-full"></div>
                        </div>
                      </div>
                    ))}
                </div>
              ))}
          </div>
          <div className="hidden w-full space-y-10 px-4 py-6 xl:sticky xl:flex xl:flex-col">
            {/* Experience Section Skeleton */}
            <div>
              <div className="mb-2 h-6 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
              <ul className="divide-y divide-gray-200 dark:divide-gray-700">
                {[1, 2, 3].map((_, index) => (
                  <li
                    key={index}
                    className="flex items-center space-x-4 py-4 animate-pulse"
                  >
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-300 dark:bg-gray-700"></div>
                    <div>
                      <div className="h-5 w-24 bg-gray-200 dark:bg-gray-700 rounded mb-2"></div>
                      <div className="h-4 w-40 bg-gray-200 dark:bg-gray-700 rounded"></div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* Education Section Skeleton */}
            <div>
              <div className="mb-2 h-6 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
              <ul className="divide-y divide-gray-200 dark:divide-gray-700">
                {[1, 2].map((_, index) => (
                  <li
                    key={index}
                    className="flex items-center space-x-4 py-4 animate-pulse"
                  >
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-300 dark:bg-gray-700"></div>
                    <div>
                      <div className="h-5 w-40 bg-gray-200 dark:bg-gray-700 rounded mb-2"></div>
                      <div className="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded"></div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <div className="relative grid grid-cols-1 overflow-y-hidden xl:h-[calc(100vh-4rem)] xl:grid-cols-4 xl:gap-4">
          <UserProfile member={member} />
          <UserFeed member={member} />
        </div>
      )}
    </NavbarSidebarLayout>
  );
};

const UserProfile: FC<{ member: any | null }> = ({ member }) => {
  if (!member) return <div>No member data available</div>;

  return (
    <div className=" w-full space-y-10 px-4 py-6 xl:sticky xl:flex xl:flex-col">
      <div>
        {/* <h3 className="mb-2 text-base font-bold text-gray-900 dark:text-white">
            Experience
          </h3> */}
        <ul className="divide-y divide-gray-200 dark:divide-gray-700">
          <li className="flex items-center m-auto space-x-4 ">
            {member.profilePhoto && member.profilePhoto !== "null" ? (
              <img
                className=" h-20 w-20 rounded-lg"
                src={member.profilePhoto}
                alt={`${member.fullName} avatar`}
              />
            ) : (
              <img
                className=" h-20 w-20 rounded-lg"
                src={`https://api.dicebear.com/9.x/initials/svg?seed=${member.fullName}`}
                alt={`${member.fullName} avatar`}
              />
            )}
            <div>
              <div className="text-base font-semibold text-gray-900 dark:text-white">
                {member?.fullName || "Unknown User"}
              </div>
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                <p>Email - {member?.email || "Not Specified"}</p>
                <p>
                  <a
                    href={`tel:${member.mobileNumber}`}
                    className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
                  >
                    Mobile - {member.mobileNumber || "Not Specified"}
                  </a>
                </p>
                <p>Address - {member.address || "Not Specified"}</p>
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div className="xl:sticky">
        <h3 className="mb-4 -mt-4 text-base font-bold text-gray-900 dark:text-white">
          Member Details
        </h3>
        <ul className="divide-y divide-gray-200 dark:divide-gray-700">
          <li className="flex items-center space-x-4 pb-4">
            {/* <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ">
              Su
            </div> */}
            <img
              className=" h-10 w-10 shrink-0 items-center justify-center rounded-lg "
              src={`https://api.dicebear.com/9.x/bottts/svg?seed=F`}
              alt={`${member.fullName} avatar`}
            />
            <div>
              <div className="text-sm font-normal text-gray-500 dark:text-gray-400">
                <strong>Gender:</strong> {member.gender || "Not Specified"}
              </div>
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                <strong>Date of Birth:</strong>{" "}
                {new Date(member.dateOfBirth).toLocaleDateString() ||
                  "Not Specified"}
              </span>
            </div>
          </li>
          <li className="flex items-center space-x-4 pt-4 pb-4">
            <img
              className=" h-10 w-10 shrink-0 items-center justify-center rounded-lg "
              src={`https://api.dicebear.com/9.x/bottts/svg?seed=p`}
              alt={`${member.fullName} avatar`}
            />
            <div>
              <div className="text-sm font-normal text-gray-500 dark:text-gray-400">
                <strong>Start Date:</strong>{" "}
                {new Date(member.startDate).toLocaleDateString() ||
                  "Not Specified"}
              </div>
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                <strong>Plan Name:</strong>{" "}
                {member.plan?.planName || "Not Specified"}
              </span>
            </div>
          </li>
          <li className="flex items-center space-x-4 pt-4 pb-4">
            <img
              className=" h-10 w-10 shrink-0 items-center justify-center rounded-lg "
              src={`https://api.dicebear.com/9.x/bottts/svg?seed=E`}
              alt={`${member.fullName} avatar`}
            />
            <div>
              <div className="text-sm font-normal text-gray-500 dark:text-gray-400">
                <strong>Amount:</strong>{" "}
                {member.plan?.amount
                  ? `₹${member.plan.amount.toFixed(2)}`
                  : "Not Specified"}
              </div>
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                <strong>Duration:</strong> {member.plan?.duration} days
              </span>
            </div>
          </li>
          <li className="flex items-center space-x-4 pt-4 pb-4">
            <img
              className=" h-10 w-10 shrink-0 items-center justify-center rounded-lg "
              src={`https://api.dicebear.com/9.x/bottts/svg?seed=k`}
              alt={`${member.fullName} avatar`}
            />
            <div>
              <div className="text-sm font-normal text-gray-500 dark:text-gray-400">
                <strong>Goal:</strong> {member.goal || "Not Specified"}
              </div>
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                <strong>Remarks:</strong> {member.remarks || "None"}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

const UserFeed: FC<{ member: any | null }> = ({ member }) => {
  const [showPastRecords, setShowPastRecords] = useState(false);
  const [showFutureRecords, setShowFutureRecords] = useState(false);
  // const { dummy, setDummy } = useAppContext();

  const currentMonth = new Date().toLocaleString("default", { month: "long" });
  const currentYear = new Date().getFullYear();

  {/* Group payments by year */ }
  const paymentsByYear = member?.paymentHistory.future.reduce((acc: any, payment: any) => {
    const year = payment.year;
    if (!acc[year]) {
      acc[year] = [];
    }
    acc[year].push(payment);
    return acc;
  }, {});
  {/* Group past payments by year */ }
  const pastPaymentsByYear = member?.paymentHistory.past.reduce((acc: any, payment: any) => {
    const year = payment.year;
    if (!acc[year]) {
      acc[year] = [];
    }
    acc[year].push(payment);
    return acc;
  }, {});
  // const handleCheckboxChange = async (e: any, payment: any) => {
  //   const newIsPaid = e.target.checked;

  //   try {
  //     const data = { isPaid: newIsPaid };
  //     // Call the update API
  //     await memberService.updatePaymentRecord(member._id, payment._id, data);
  //     setDummy(!dummy);
  //     // Play success sound
  //     const audio = new Audio('/cash.mp3'); // Ensure the file exists in the public folder
  //     audio.play();
  //     toast.success("Payment status updated successfully");
  //   } catch (error: any) {
  //     toast.error(error.message || "Failed to update payment status.");
  //   }
  // };
  return (
    <>
      <div className="col-span-2 m-auto mb-20 h-full w-full max-w-3xl space-y-6 overflow-hidden overflow-y-auto p-4 lg:pt-6">
        <div className="fixed sm:relative bottom-0 z-50 w-full h-16 -translate-x-1/2 bg-white border-t border-gray-200 left-1/2 dark:bg-gray-700 dark:border-gray-600 sm:rounded-xl">
          <div className="grid h-full max-w-lg grid-cols-4 mx-auto">
            <button
              onClick={() => {
                setShowPastRecords(!showPastRecords);
                setShowFutureRecords(false);
              }}
              type="button"
              className={`relative inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group ${showPastRecords && "bg-gray-50 dark:bg-gray-800"
                }`}
            >
              <LuHistory className="text-2xl dark:text-white" />
              <span className="sr-only">New document</span>

              {/* Tooltip */}
              <div
                className="absolute whitespace-nowrap top-full mt-2 hidden px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-0 transition-opacity duration-300 group-hover:opacity-100 group-hover:inline-block dark:bg-gray-700"
                role="tooltip"
              >
                Past Records
                {/* <div className="tooltip-arrow" data-popper-arrow="" /> */}
              </div>
            </button>

            {/* <button
              data-tooltip-target="tooltip-bookmark"
              type="button"
              className="inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group"
            >
              <svg
                className="w-5 h-5 mb-1 text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 14 20"
              >
                <path d="M13 20a1 1 0 0 1-.64-.231L7 15.3l-5.36 4.469A1 1 0 0 1 0 19V2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v17a1 1 0 0 1-1 1Z" />
              </svg>
              <span className="sr-only">Bookmark</span>
            </button> */}
            <div
              id="tooltip-bookmark"
              role="tooltip"
              className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
            >
              Bookmark
              <div className="tooltip-arrow" data-popper-arrow="" />
            </div>
            <div className="flex items-center justify-center col-span-2">
              <>
                <AddPaymentCardModal memberId={member?._id} />
              </>
            </div>
            {/* <button
              data-tooltip-target="tooltip-settings"
              type="button"
              className="inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group"
            >
              <svg
                className="w-5 h-5 mb-1 text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 12.25V1m0 11.25a2.25 2.25 0 0 0 0 4.5m0-4.5a2.25 2.25 0 0 1 0 4.5M4 19v-2.25m6-13.5V1m0 2.25a2.25 2.25 0 0 0 0 4.5m0-4.5a2.25 2.25 0 0 1 0 4.5M10 19V7.75m6 4.5V1m0 11.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM16 19v-2"
                />
              </svg>
              <span className="sr-only">Settings</span>
            </button> */}
            <div
              id="tooltip-settings"
              role="tooltip"
              className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
            >
              Settings
              <div className="tooltip-arrow" data-popper-arrow="" />
            </div>
            <button
              onClick={() => {
                setShowPastRecords(false);
                setShowFutureRecords(!showFutureRecords);
              }}
              type="button"
              className={`relative inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group ${showFutureRecords && "bg-gray-50 dark:bg-gray-800"
                }`}
            >
              <AiOutlineHistory className="text-2xl font-semibold dark:text-white" />
              <span className="sr-only">Profile</span>

              {/* Tooltip */}
              <div
                className="absolute top-full mt-2 hidden px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-0 transition-opacity duration-300 group-hover:opacity-100 group-hover:inline-block dark:bg-gray-700 whitespace-nowrap"
                role="tooltip"
              >
                Upcoming Records
                {/* <div className="tooltip-arrow" data-popper-arrow="" /> */}
              </div>
            </button>
          </div>
        </div>
        {member && (
          <>
            {/* Map over current payments */}
            {member.paymentHistory.current?.length > 0 ? (
              member.paymentHistory.current.map((payment: any) => (
                <div key={payment._id}>
                  <h3 className="mb-4 -mt-8 sm:mt-0 text-base font-bold text-gray-900 dark:text-white">
                    Transactions
                  </h3>
                  <Card className="border-2 border-blue-300 dark:border-blue-300 shadow-xl">
                    {/* Card content for current payment */}
                    <div className="flex items-center space-x-1 lg:space-x-4 relative">
                      <div className="shrink-0 relative">
                        {member.profilePhoto && member.profilePhoto !== "null" ? (
                          <img
                            className="h-10 w-10 rounded-full"
                            src={member.profilePhoto}
                            alt={`${member.fullName} avatar`}
                          />
                        ) : (
                          <img
                            className="h-10 w-10 rounded-full"
                            src={`https://api.dicebear.com/9.x/initials/svg?seed=${member.fullName}`}
                            alt={`${member.fullName} avatar`}
                          />
                        )}

                      </div>
                      {/* Badge for month/year on top of profile image */}

                      <span className="relative bg-yellow-100 text-yellow-800 text-xs font-medium  px-2.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300 whitespace-nowrap sm:hidden">{`${payment.month.slice(0, 3)}${String(payment.year).slice(-2)}`}</span>
                      <div className="min-w-0 flex-1">
                        {/* Full name - hidden on small devices */}
                        <p className="truncate text-sm font-semibold text-gray-900 dark:text-white hidden sm:block">
                          {member.fullName}
                        </p>
                        {/* Month and year - hidden on small devices */}
                        <p className="truncate text-sm font-normal text-gray-500 dark:text-gray-400 hidden sm:block">
                          {payment.month} {payment.year}
                        </p>
                      </div>

                      <p className="dark:text-white">{`₹${payment?.plan?.amount}`}</p>
                      <label className="inline-flex items-center me-5 cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={payment.isPaid}
                          onChange={(e) => {}}
                        />
                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600" />
                        <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300 hidden sm:inline">
                          {payment.isPaid ? "Paid" : "Unpaid"}
                        </span>
                      </label>
                      <EditPaymentCardModal payment={payment} member={member} />
                    </div>

                  </Card>
                </div>
              ))
            ) : (
              <div className="mt-4 text-center">
                <h3 className="text-base font-bold text-gray-900 dark:text-white">
                  No Transactions Found
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  There are no payment records for the current month.
                </p>
              </div>
            )}

            {/* Map over past payments */}
            {showPastRecords && (
              Object.keys(pastPaymentsByYear).length > 0 ? (
                Object.entries(pastPaymentsByYear).map(([year, payments]: any) => (
                  <div key={year}>
                    <h2 className="text-lg font-bold text-gray-800 dark:text-white mb-4">{year}</h2>
                    {payments.map((payment: any) => (
                      <Card
                        key={payment._id}
                        className="border border-gray-200 dark:border-gray-700 mt-4"
                      >
                        {/* Card content for past payments */}
                        <div className="flex items-center space-x-1 lg:space-x-4  ">
                          <div className="shrink-0">
                            {member.profilePhoto && member.profilePhoto !== "null" ? (
                              <img
                                className="h-10 w-10 rounded-full"
                                src={member.profilePhoto}
                                alt={`${member.fullName} avatar`}
                              />
                            ) : (
                              <img
                                className="h-10 w-10 rounded-full"
                                src={`https://api.dicebear.com/9.x/initials/svg?seed=${member.fullName}`}
                                alt={`${member.fullName} avatar`}
                              />
                            )}
                          </div>
                          {/* Badge for month/year on top of profile image */}

                          <span className="relative bg-yellow-100 text-yellow-800 text-xs font-medium  px-2.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300 whitespace-nowrap sm:hidden">{`${payment.month.slice(0, 3)}${String(payment.year).slice(-2)}`}</span>
                          <div className="min-w-0 flex-1">
                            <p className="truncate text-sm font-semibold text-gray-900 dark:text-white hidden sm:block">
                              {member.fullName}
                            </p>
                            <p className="truncate text-sm font-normal text-gray-500 dark:text-gray-400 hidden sm:block">
                              {payment.month} {payment.year}
                            </p>
                          </div>
                          <p className="dark:text-white">
                            {`₹${payment.plan?.amount}`}
                          </p>
                          <p className="bg-red-100 text-red-800 text-[14px] font-medium me-2 px-2.5 py-0.5 rounded-full dark:bg-red-900 dark:text-red-300">
                            {payment.isPaid ? "Paid" : "Unpaid"}
                          </p>
                          <EditPaymentCardModal payment={payment} member={member} />
                        </div>
                      </Card>
                    ))}
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-500 dark:text-gray-400">
                  <p>No past payment records available.</p>
                </div>
              )
            )}

            {/* Map over grouped future payments */}
            <div className="card-container">
              {showFutureRecords && (
                Object.keys(paymentsByYear).length > 0 ? (
                  Object.entries(paymentsByYear).map(([year, payments]: any) => (
                    <div key={year}>
                      <h2 className="text-lg font-bold text-gray-800 dark:text-white mb-4">{year}</h2>
                      {payments && payments.map((payment: any) => (
                        <Card
                          key={payment._id}
                          className="card border border-gray-200 dark:border-gray-700"
                        >
                          {/* Card content for future payments */}
                          <div className="flex items-center space-x-1 lg:space-x-4  ">
                            <div className="shrink-0">
                              {member.profilePhoto && member.profilePhoto !== "null" ? (
                                <img
                                  className="h-10 w-10 rounded-full"
                                  src={member.profilePhoto}
                                  alt={`${member.fullName} avatar`}
                                />
                              ) : (
                                <img
                                  className="h-10 w-10 rounded-full"
                                  src={`https://api.dicebear.com/9.x/initials/svg?seed=${member.fullName}`}
                                  alt={`${member.fullName} avatar`}
                                />
                              )}
                            </div>
                            {/* Badge for month/year on top of profile image */}

                            <span className="relative bg-yellow-100 text-yellow-800 text-xs font-medium  px-2.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300 whitespace-nowrap sm:hidden">{`${payment.month.slice(0, 3)}${String(payment.year).slice(-2)}`}</span>
                            <div className="min-w-0 flex-1">
                              <p className="truncate text-sm font-semibold text-gray-900 dark:text-white hidden sm:block">
                                {member.fullName}
                              </p>
                              <p className="truncate text-sm font-normal text-gray-500 dark:text-gray-400 hidden sm:block">
                                {payment.month} {payment.year}
                              </p>
                            </div>
                            <p className="dark:text-white">
                              {`₹${payment.plan?.amount}`}
                            </p>
                            <p className="bg-gray-100 text-gray-800 text-[14px] font-medium me-2 px-2.5 py-0.5 rounded-full dark:bg-gray-900 dark:text-gray-300">
                              {payment.isPaid ? "Paid" : "Unpaid"}
                            </p>
                            <EditPaymentCardModal payment={payment} member={member} />
                          </div>
                        </Card>
                      ))}
                    </div>
                  ))
                ) : (
                  <div className="text-center text-gray-500 dark:text-gray-400">
                    <p>No future payment records available.</p>
                  </div>
                )
              )}

            </div>
          </>
        )}
      </div>
      <div className="hidden w-full space-y-10 px-4 py-6 xl:sticky xl:flex xl:flex-col">
        <div>
          <h3 className="mb-2 text-base font-bold text-gray-900 dark:text-white">
            Blogs
          </h3>
          <ul className="divide-y divide-gray-200 dark:divide-gray-700">
            <li className="flex items-center space-x-4 pb-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-purple-600">
                <svg
                  className="h-6 w-6"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.99686 17.2745H13.9083L19.125 12.1409V0.15625H1.30428L0 3.5802V17.2745H4.77995V19.8438H7.3895L9.99686 17.2745ZM17.3867 1.86719V11.283L14.3433 14.2794H9.5625L6.95605 16.845V14.2794H3.04181V1.86719H17.3867ZM7.82358 10.4284H9.56252V5.293H7.82358V10.4284ZM14.3433 10.4284H12.6048V5.293H14.3433V10.4284Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div>
                <div className="text-base font-semibold text-gray-900 dark:text-white">
                  Twitch
                </div>
                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                  Web Developer, New York USA
                </span>
              </div>
            </li>
            <li className="flex items-center space-x-4 py-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-900">
                <svg
                  className="h-6 w-6"
                  viewBox="0 0 17 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.6548 0.5C12.6548 0.5 10.7499 0.508901 9.37979 2.32747C8.16141 3.94464 8.47161 5.3278 8.47161 5.3278C8.47161 5.3278 10.1236 5.61559 11.5769 3.85687C12.9381 2.20979 12.6548 0.5 12.6548 0.5ZM9.73865 6.19398C9.29026 6.376 8.92182 6.52555 8.64585 6.52555C8.30184 6.52555 7.88681 6.36455 7.40452 6.17745C6.73565 5.91797 5.93739 5.6083 5.01974 5.60828C2.59022 5.60828 0 7.79898 0 11.9751C0 16.2196 3.06015 21.5 5.48241 21.5C5.85921 21.5 6.32593 21.3297 6.84337 21.1408C7.48701 20.9059 8.20912 20.6423 8.93429 20.6423C9.58452 20.6423 10.1484 20.8545 10.7049 21.0638C11.2471 21.2678 11.7823 21.4692 12.3835 21.4692C15.0361 21.4692 17 15.9026 17 15.9026C17 15.9026 14.1906 14.8073 14.1906 11.6288C14.1906 8.81133 16.4459 7.65016 16.4459 7.65016C16.4459 7.65016 15.2928 5.54981 12.3617 5.54981C11.3256 5.54981 10.4355 5.91109 9.73865 6.19398Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div>
                <div className="text-base font-semibold text-gray-900 dark:text-white">
                  Apple
                </div>
                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                  React Developer, Palo Alto USA
                </span>
              </div>
            </li>
            <li className="flex items-center space-x-4 pt-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white shadow">
                <svg
                  className="h-6 w-6"
                  viewBox="0 0 21 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.989 11.2057C20.989 10.3044 20.9175 9.64668 20.7629 8.9646H10.7092V13.0328H16.6105C16.4916 14.0437 15.8491 15.5663 14.4213 16.5894L14.4013 16.7256L17.5801 19.2466L17.8003 19.2691C19.8229 17.3568 20.989 14.5431 20.989 11.2057Z"
                    fill="#4285F4"
                  />
                  <path
                    d="M10.7092 21.9245C13.6004 21.9245 16.0275 20.95 17.8003 19.2692L14.4213 16.5895C13.5171 17.2351 12.3035 17.6857 10.7092 17.6857C7.87755 17.6857 5.4742 15.7735 4.61747 13.1304L4.49189 13.1413L1.18654 15.76L1.14331 15.8831C2.90418 19.464 6.52114 21.9245 10.7092 21.9245Z"
                    fill="#34A853"
                  />
                  <path
                    d="M4.61755 13.1303C4.39149 12.4482 4.26066 11.7174 4.26066 10.9622C4.26066 10.207 4.39149 9.47622 4.60565 8.79413L4.59966 8.64887L1.25289 5.98804L1.14339 6.04136C0.41765 7.52737 0.0012207 9.19609 0.0012207 10.9622C0.0012207 12.7284 0.41765 14.397 1.14339 15.883L4.61755 13.1303Z"
                    fill="#FBBC05"
                  />
                  <path
                    d="M10.7092 4.23869C12.7199 4.23869 14.0763 5.12785 14.8496 5.87089L17.8717 2.85018C16.0157 1.08405 13.6004 0 10.7092 0C6.52113 0 2.90418 2.46039 1.14331 6.04135L4.60557 8.79412C5.4742 6.15102 7.87754 4.23869 10.7092 4.23869Z"
                    fill="#EB4335"
                  />
                </svg>
              </div>
              <div>
                <div className="text-base font-semibold text-gray-900 dark:text-white">
                  Google
                </div>
                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                  Frontend Dev, Calfornia USA
                </span>
              </div>
            </li>
          </ul>
        </div>
        <div className="xl:sticky">
          <h3 className="mb-2 text-base font-bold text-gray-900 dark:text-white">
            Education
          </h3>
          <ul className="divide-y divide-gray-200 dark:divide-gray-700">
            <li className="flex items-center space-x-4 pb-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ">
                Su
              </div>
              <div>
                <div className="text-base font-semibold text-gray-900 dark:text-white">
                  Stanford University
                </div>
                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                  Computer Science and Engineering
                </span>
              </div>
            </li>
            <li className="flex items-center space-x-4 pt-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-700 text-sm font-bold uppercase text-white">
                Th
              </div>
              <div>
                <div className="text-base font-semibold text-gray-900 dark:text-white">
                  Thomas Jeff High School
                </div>
                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                  Secondary School Certificate
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default UserFeedPage;
